<template>
  <div>
    <v-simple-table v-if="!loading && paymentItems && paymentItems.length" dense>
      <template v-slot:default>
        <thead>
        <tr>
          <th>Campaign Id</th>
          <th>Geo</th>
          <th>Quantity</th>
          <th>Price Per Action</th>
          <th>Currency Rate</th>
          <th>Converted Amount</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(pi, index) in paymentItems" :key="`items-${payment.id}-${index}`">
          <td>{{pi.campaignId}}</td>
          <td>{{pi.geo}}</td>
          <td>{{pi.count}}</td>
          <td>{{pi.itemCurrency}}{{pi.amount.toFixed(2)}}</td>
          <td>{{pi.currencyRate}}</td>
          <td>{{payment.currencySymbol}}{{ pi.sumAmount.toFixed(2)}}</td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
    <div v-else-if="loading" class="text-center">
      <v-progress-circular size="50" indeterminate color="primary"></v-progress-circular>
    </div>
    <p class="v-subheader h3" v-else>
      There is no payment items yet.
    </p>
  </div>
</template>

<script>
import paymentsApi from "@/api/payments";

export default {
  name: "PaymentItems",
  props: {
    payment: {
      type: Object,
    },
  },
  data() {
    return {
      loading: false,
      paymentItems: [],
    }
  },
  async mounted() {
    if (this.payment.id && !this.paymentItems.length) {
      this.loading = true;
      try {
        this.paymentItems = await paymentsApi.getPaymentItems({paymentId: this.payment.id});
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>

</style>
